import { SagaIterator } from "redux-saga";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setUpdateCourseError } from "../../repository/slice";

function* updateCourseWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.put, "/api/admin/courses/" + payload.id, payload.body);
        if (isError) {
            yield put(setUpdateCourseError(message));
        } else {
            yield put(setUpdateCourseError(null));
        }
    } catch (error) {
        console.error("updateCourseWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* updateCourseWatcher() {
    yield takeLatest("@saga/UPDATE_COURSE", updateCourseWorker);
};
